import React, { useMemo } from "react";
import { sum } from "lodash";
import { Button, Flex, Text, toast } from "@jsq/ds/core";
import { ErrorPage, ErrorType } from "../../../../common/components/ErrorPage";
import { stackedMd, stackedLg } from "../../../../common/themes/spacing_styles_vanilla.css";
import { useConsolidatedPaymentPrefContext } from "../../Context";
import { AccountsTable } from "../AccountsTable";
import { PaymentPrefConfirmationDisplayCard } from "../PaymentPrefConfirmationDisplayCard";
import { type ChildComponentProps } from "../types";
import { getSummaryDescription, getToastSuccessMessage } from "./utils";

export const SummaryOfChanges: React.FC<ChildComponentProps> = ({ onContinueClick }) => {
  const {
    accounts,
    selectedPaymentPref,
    selectedPaymentMethod,
    paymentPrefDetail,
    updatedPositionsPerAccount,
  } = useConsolidatedPaymentPrefContext();

  const positionsCount = useMemo(
    () =>
      sum(
        Object.values(updatedPositionsPerAccount || {}).map(
          (updatedPositionIds) => updatedPositionIds.length,
        ),
      ),
    [updatedPositionsPerAccount],
  );

  if (
    !accounts ||
    (!selectedPaymentPref && !paymentPrefDetail) ||
    !updatedPositionsPerAccount
  ) {
    return <ErrorPage error={ErrorType.InternalError} />;
  }

  const accountsCount = Object.keys(updatedPositionsPerAccount || {}).length;
  const description = getSummaryDescription({ positionsCount, accountsCount });

  const onFinishClick = () => {
    onContinueClick();
    toast.info(
      getToastSuccessMessage({
        paymentMethod: selectedPaymentMethod,
        positionsCount,
        accountsCount,
      }),
      { position: "bottom-center" },
    );
  };

  return (
    <>
      <Text className={stackedLg} variant="h3">
        Summary of changes
      </Text>
      <Text className={stackedMd}>{description}</Text>
      <div className={stackedLg}>
        <PaymentPrefConfirmationDisplayCard />
      </div>
      <div className={stackedLg}>
        <AccountsTable
          accounts={accounts}
          updatedPositionsPerAccount={updatedPositionsPerAccount}
        />
      </div>
      <Flex flexDirection="row-reverse" gap={8}>
        <Button onClick={onFinishClick}>Finish</Button>
      </Flex>
    </>
  );
};
